/**
 * @file dream
 * @author 丁聪
 */

import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';

import './index.scss'

@withTranslation()


class Dream extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  componentDidMount() { }

  render() {
    let { t } = this.props;
    let introlist = [
      {
        img: `//cdn.ihatoo.com/hatu-official/teacher/f3-icon-zlcx-s.png`,
        title: t('teacher:introduc_item1_title'),
        intro: t('teacher:introduc_item1_intro'),
      },
      {
        img: `//cdn.ihatoo.com/hatu-official/teacher/f3-icon-spms-n.png`,
        title: t('teacher:introduc_item2_title'),
        intro: t('teacher:introduc_item2_intro'),
      },
      {
        img: `//cdn.ihatoo.com/hatu-official/teacher/f3-icon-pxkh-n.png`,
        title: t('teacher:introduc_item3_title'),
        intro: t('teacher:introduc_item3_intro'),
      },
      {
        img: `//cdn.ihatoo.com/hatu-official/teacher/f3-icon-gxfk-n.png`,
        title: t('teacher:introduc_item4_title'),
        intro: t('teacher:introduc_item4_intro'),
      },

    ]
    return (
      <div id="dream">
        <div className="inner">
          <div className="study-title">{t('teacher:introduc')}</div>
          <div className="heng"></div>
          <ul className="intro">
            {introlist.map((item, index) => (
              <li key={'intro-' + index}  >
                <div className="img" ></div>
                <div className="title">{item.title}</div>
                <div className="intro">{item.intro}</div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    )
  }
}

export default Dream
